import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick"];
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { adjustLuminance } from 'visitor-ui-component-library/utils/adjustLuminance';
import { EERIE, OLAF, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import CloseIcon from './CloseIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledIconButton = styled(VizExIconButton)(({
  theme
}) => {
  var _theme$config;
  const isUngatedForCustomerAgentPrompts = theme === null || theme === void 0 || (_theme$config = theme.config) === null || _theme$config === void 0 ? void 0 : _theme$config.isUngatedForCustomerAgentPrompts;
  const baseColor = isUngatedForCustomerAgentPrompts ? OBSIDIAN : EERIE;
  const size = isUngatedForCustomerAgentPrompts ? '16px' : '24px';
  return {
    position: 'absolute',
    top: '-32px',
    right: '24px',
    height: size,
    width: size,
    borderRadius: '20px',
    backgroundColor: baseColor,
    color: baseColor,
    border: `1px solid ${baseColor}`,
    fontSize: '12px',
    '&:hover:enabled': {
      backgroundColor: adjustLuminance(baseColor, 10),
      borderColor: baseColor
    },
    '&:active:enabled': {
      backgroundColor: adjustLuminance(baseColor, -10),
      borderColor: baseColor
    }
  };
});
const CloseButton = _ref => {
  let {
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledIconButton, Object.assign({
    shape: "circle",
    onClick: onClick
  }, rest, {
    children: /*#__PURE__*/_jsx(VizExIcon, {
      icon: /*#__PURE__*/_jsx(CloseIcon, {
        height: 8,
        width: 8,
        color: OLAF
      })
    })
  }));
};
CloseButton.displayName = 'VisitorWidgetCloseButton';
export default CloseButton;